import ProjectContainer from '@/modules/neopvc/pages/project/container.page.vue';
import ListPage from '@/modules/neopvc/pages/project/list.page.vue';
import FormPage from '@/modules/neopvc/pages/project/form.page.vue';
import ProcessPage from '@/modules/neopvc/pages/project/process.page.vue';
import AuditPage from '@/modules/neopvc/pages/project/audit.page.vue';

import { tabs } from './models';

export const neopvcRoutes = [
  {
    path: `${process.env.BASE_URL}neopvc`,
    component: () => import('@/layout/default.layout.vue'),
    children: [
      {
        path: 'project',
        component: ProjectContainer,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            components: {
              [tabs.list]: ListPage,
            },
          },
          {
            path: tabs.form,
            components: {
              [tabs.form]: FormPage,
            },
          },
          {
            path: tabs.process,
            components: {
              [tabs.process]: ProcessPage,
            },
          },
          {
            path: tabs.audit,
            components: {
              [tabs.audit]: AuditPage,
            },
          },
        ],
      },
    ],
  },
];
